// ewiSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quarterList: [],
  selectedQuarter: null,
  selectedCohortOnFHS: null,
  isEWIExist: false,
};

const ewiSlice = createSlice({
  name: "ewi",
  initialState,
  reducers: {
    setSelectedQuarter: (state, action) => {
      state.selectedQuarter = action.payload;
    },
    setselectedCohortOnFHS: (state, action) => {
      state.selectedCohortOnFHS = action.payload;
    },
    setIsEWIExist: (state, action) => {
      state.isEWIExist = action.payload;
    },
    resetSelectedQuarter: (state, action) => {
      // return initialState;
      state.quarterList = [];
      state.selectedQuarter = null;
      state.selectedCohortOnFHS = null;
    },
  },
});

export const {
  setSelectedQuarter,
  setselectedCohortOnFHS,
  resetSelectedQuarter,
  setIsEWIExist,
} = ewiSlice.actions;
export default ewiSlice.reducer;
